import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Select as AndSelect, Spin } from 'antd';
import styled, { css } from 'styled-components';
const { Option } = AndSelect;
export const SelectFieldWrapper = styled.div `
  position: relative;
  ${({ required }) => required &&
    css `
      &:before {
        content: '*';
        position: absolute;
        top: -2px;
        right: 16px;
        color: #ff4016;
        height: 12px;
        font-size: 18px;
        line-height: 12px;
        z-index: 4;
      }
    `}
`;
const SelectField = styled(AndSelect) `
  width: 100%;
  --bc-control-height: 40px;
  &.bc-select-filled {
    --bc-font-family: 14px;
    --bc-line-height: calc(14px + 4px);
    --bc-border-radius: 15px;
    --bc-input-padding-block: calc(calc(5 * 1px) * 2);
    --bc-input-padding-inline: calc(calc(5 * 1px) * 3);
    --bc-color-fill-tertiary: hsla(0, 0%, 0%, 0.07);
    --bc-color-text: hsla(0, 0%, 33.33%, 1) !important;
    border-color: transparent;
  }

  --bc-color-bg-elevated: hsla(0, 0%, 100%, 1);

  &.bc-select-status-error:not(.bc-select-customize-input) .bc-select-selector {
    box-shadow: inset 0 0 0 2px
      hsla(
        var(--ue-danger-color_h, 2),
        var(--ue-danger-color_s, 77%),
        var(--ue-danger-color_l, 64%),
        var(--ue-danger-color_t, 1)
      ) !important;
  }
  &.bc-select-focused {
    .bc-select-selector {
      --bc-color-fill-tertiary: hsla(
        var(--ue-input-hover-color_h, 0),
        var(--ue-input-hover-color_s, 0%),
        var(--ue-input-hover-color_l, 0%),
        var(--ue-input-hover-color_t, 0.1)
      );
      box-shadow: inset 0 0 0 2px hsla(129, 60%, 50%, 1);
    }
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    pointer-events: auto;
    --bc-color-fill-tertiary: hsla(0, 0%, 0%, 0.07);
    --bc-color-text-disabled: hsla(0, 0%, 33.33%, 1) !important;
    background: var(--bc-color-fill-tertiary);
  }

  &.bc-select-multiple {
    .bc-select-selector {
      padding-inline: 10px !important;
      padding-block: 5px !important;
    }
    .bc-select-selection-item {
      --bc-color-split: hsla(0, 0%, 0%, 0.07);
      --bc-border-radius-sm: 8px;
      font-size: var(--ue-font-size, 13px);
    }
  }
`;
export const ErrorMessage = styled.div `
  position: absolute;
  min-width: calc(calc(calc(5 * 1px) * 3) * 2 + 47px);
  bottom: calc(100% + calc(5 * 1px) - 2px);
  z-index: 15;
  opacity: 0;
  transform: scale(0);

  ${SelectFieldWrapper}:hover & {
    ${({ error }) => error &&
    css `
        animation: ca-error-show 0.15s cubic-bezier(0, 0, 0.2, 1) forwards;
      `};
  }

  span {
    background-color: hsla(2, 77%, calc(64% - 3%), 1);
    ${({ error }) => error &&
    css `
        padding: calc(calc(var(--ue-spacing-step-px, 1) * 1px) + 2px) calc(calc(5 * 1px) * 2);
      `};
    border-radius: 15px;
    min-width: calc(calc(calc(5 * 1px) * 3) * 2 + 47px);
    text-align: center;
    box-sizing: border-box;
    font-size: calc(14px - 2px);
    line-height: 14px;
    color: hsla(
      var(--ue-secondary-font-color_h, 0),
      var(--ue-secondary-font-color_s, 0%),
      var(--ue-secondary-font-color_l, 100%),
      var(--ue-secondary-font-color_t, 1)
    );
  }

  @keyframes ca-error-show {
    0% {
      opacity: 0;
      transform: scale(0);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }
`;
const Select = ({ placeholder = 'Select an option', options, defaultValue, showSearch = false, optionFilterProp = 'label', onChange, onSearch, required = false, value, error, disabled = false, loading = false, ...props }) => {
    return (_jsxs(SelectFieldWrapper, { required: required, children: [_jsx(SelectField, { showSearch: showSearch, optionFilterProp: optionFilterProp,
                //@ts-ignore
                onChange: onChange, onSearch: onSearch, placeholder: placeholder, options: options, required: required, notFoundContent: loading ? _jsx(Spin, { size: "small" }) : 'No Data Found', value: value, defaultValue: defaultValue, disabled: disabled, status: error ? 'error' : undefined, ...props }), _jsx(ErrorMessage, { error: error, children: _jsx("span", { children: error }) })] }));
};
export default Select;
